import useWidth from '@components/Hooks/useWidth';
import { MODAL_MOBILE_MODE } from '../modal.constants';
import type { ModalSize } from '../modal.types';

interface UseModalResponsiveResult {
  isFullScreen: boolean;
  isDrawer: boolean;
}

export const useModalResponsive = (size: ModalSize): UseModalResponsiveResult => {
  const { mobileWidth } = useWidth();
  const mobileMode = mobileWidth ? MODAL_MOBILE_MODE[size] : 'dialog';

  return {
    isFullScreen: mobileMode === 'fullscreen',
    isDrawer: mobileMode === 'drawer',
  };
};
